/* eslint-disable */
// @ts-nocheck
import isUrl from 'is-url';

/**
 * This file is used to solve the problem that the dynamic import static resource path is incorrect after the sub-application is packaged.
 *
 * We can't directly use `__webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__`,
 * and must check the `__INJECTED_PUBLIC_PATH_BY_QIANKUN__` and `process.env.PUBLIC_PATH`.
 *
 * This's because we use the `HtmlWebpackPlugin` to produce others 3 html for odp, ads and app,
 * and config the nginx path rewrite like: `/odp/ -> /odp/index.html`.
 *
 * When we enter ODP, `__INJECTED_PUBLIC_PATH_BY_QIANKUN__` will be equal to `${origin}${PUBLIC_PATH}/odp`.
 * Dynamic module resources imported from this path cannot be found.
 * It needs to be changed to `${origin}${PUBLIC_PATH}`.
 */

if (window.__POWERED_BY_QIANKUN__) {
  const configPublicPath = process.env.PUBLIC_PATH || '/';
  let publicPath = configPublicPath;

  // Only appending host when the public path doesn't have host. This change won't affect QE and Prod
  // It's for solving the issue when indicating host of assets in local development.
  // Example:
  //  - For `http://127.0.0.1/static/js/index.js` the final public path will still be `http://127.0.0.1/static/js/index.js`
  if (!isUrl(publicPath)) {
    const qiankunPublicPath = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
    publicPath = new URL(qiankunPublicPath).origin.concat(configPublicPath);
  }

  __webpack_public_path__ = publicPath;
}
